<template>
    <div class="input-group input-daterange">
        <input class="form-control" ref="start" />
        <div class="input-group-addon">to</div>
        <input class="form-control" ref="end" />
    </div>
</template>

<script>
    export default {
        props: ['options', 'startDate', 'endDate'],
        mounted() {
            var vm = this;

            jQuery(this.$refs.start)
                .val(this.startDate)
                .on('change', function() {
                    vm.$emit('update:startDate', this.value);
                });
            jQuery(this.$refs.end)
                .val(this.endDate)
                .on('change', function() {
                    vm.$emit('update:endDate', this.value);
                });

            jQuery(this.$el)
                .datepicker(this.options);
        },
        watch: {
            startDate: function(value) {
                jQuery(this.$refs.start).val(value);
            },
            endDate: function(value) {
                jQuery(this.$refs.end).val(value);
            },
        },
        destroyed() {
            jQuery(this.$refs.start).off();
            jQuery(this.$refs.end).off();
        },
    }
</script>
